// Condição de pagamento padrão do fornecedor ([Financial].[ProviderPaymentTerm]).

/** Base do vencimento: 1 = emissão do pedido (Data do Pedido), 2 = entrega (Data Prevista). */
export type DueDateBase = 1 | 2;

export const DUE_DATE_BASE_ORDER: DueDateBase = 1;
export const DUE_DATE_BASE_DELIVERY: DueDateBase = 2;

export interface ProviderPaymentTermInstallment {
  seq?: number;
  due_date_base: DueDateBase;
  days: number;
  percent: number;
}

export interface ProviderPaymentTerm {
  provider_payment_term_id?: number;
  provider_id?: number;
  payment_method_id: number;
  payment_method_name?: string;
  /** 1 = prazo na emissão, 2 = prazo na entrega (derivado das parcelas). */
  payment_method_model_id?: number;
  notes?: string;
  installments: ProviderPaymentTermInstallment[];
  updated_at?: string;
  updated_by?: string;
}

export interface SaveProviderPaymentTermRequest {
  payment_method_id: number;
  notes?: string;
  installments: ProviderPaymentTermInstallment[];
}

export interface PaymentMethodOption {
  payment_method_id: number;
  payment_method_name: string;
}
